<template>
    <div class="container">
        <content-header title="Медицинские осмотры по Приказу Минздрава России №29н"/>
        <p style="text-align: center; font-size: 22px">Поликлиника №5 УДП РФ предлагает Вам проведение предварительных и
            периодических медицинских осмотров по Приказу Минздрава России №29н</p>
        <img src="../../assets/images/staticPages/gastroscopija-400x200.jpg" alt="gastroscopija" height="200"
             width="400" style="float: right; margin: 20px 0 20px 40px"/>
        <p>Получить индивидуальное предложение, задать любые вопросы относительно организации и правил прохождения
            медосмотров, Вы можете по телефону, электронной почте или оставив заявку на нашем сайте:</p>
        <p><strong>Тепляков Никита Валерьевич</strong></p>
        <p>
            <strong>✉ profosmotr@5-clinic.ru</strong><br>
            <strong>тел. +7 (964) 797-69-78</strong><br>
        </p>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 7}" @click="selectTable(7)">
            <h3>Заявка на расчет стоимости профосмотров</h3>
            <div class="plus" v-if="showTable !== 7">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 7">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 7">
                <static-page-contact-form></static-page-contact-form>
            </div>
        </transition>
        <div class="divider"></div>
        <p><strong>Профилактический медицинский осмотр</strong> – необходимое медицинское обследование, при котором
            определяется
            состояние здоровья и возможность человека работать в определенных производственных условиях</p>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 5}" @click="selectTable(5)">
            <h3>Цель проведения профилактических осмотров</h3>
            <div class="plus" v-if="showTable !== 5">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 5">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 5">
                <p>• определение соответствия (пригодности) рабочих и служащих поручаемой им работе, обеспечение
                    безопасности труда;<br>
                    • выявление лиц с профессиональными заболеваниями или подозрением на такие заболевания, профилактика
                    и
                    своевременное установление начальных признаков профзаболеваний;<br>
                    • выявление общих (непрофессиональных) заболеваний, при которых дальнейшая работа в контакте с
                    факторами
                    профессиональной вредности может ухудшить их течение;<br>
                    • оценка условий труда и разработка санитарно-гигиенических мероприятий, направленных на ликвидацию
                    причин, вызывающих профессиональное заболевание;<br>
                    • динамическое наблюдение за состоянием здоровья работников в условиях воздействия факторов
                    профессиональной вредности;<br>
                    • своевременное проведение профилактических и реабилитационных мероприятий, направленных на
                    сохранение
                    здоровья и восстановление трудоспособности работников;<br>
                    • предупреждение несчастных случаев.</p>
            </div>
        </transition>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 6}" @click="selectTable(6)">
            <h3>Зачем работодателю проводить медицинский осмотр сотрудников?</h3>
            <div class="plus" v-if="showTable !== 6">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 6">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <div v-if="showTable === 6">
                <p>• обязанность по проведению предварительных и периодических осмотров возлагается на работодателя
                    законом;<br>
                    • выявление и предупреждение распространения инфекционных заболеваний и паразитов;<br>
                    • предупреждение несчастные случаи на предприятии;<br>
                    • работоспособность у здоровых сотрудников выше, а следовательно он работает более эффективно;<br>
                    • забота о здоровье сотрудников повышает их лояльность работодателю.</p>
            </div>
        </transition>
        <div class="divider"></div>
        <p style="color: black; text-align: center; font-size: 16px; line-height: 20px">Доверьте заботу о здоровье Ваших
            сотрудников
            профессионалам!<br>
            Мы знаем о профосмотрах всё!<br>
            <strong style="font-size: 14px">Наши конкурентные преимущества:</strong></p>
        <p>• <strong>Профессионализм</strong> подтвержденный 30 летним опытом проведения медицинских осмотров;<br>
            • <strong>Безупречная репутация</strong> – нам доверяют крупнейшие организации с мировым именем. Многолетнее
            сотрудничество с
            подведомственными управлению делами
            Президента организациями говорит о высоком уровне партнерских отношений и достойном выполнении своих
            обязательств;<br>
            • <strong>Оперативность и качество</strong> – Наличие полного спектра необходимого оборудования, собственной
            лаборатории,
            врача-нарколога и врача-психиатра позволяет
            работнику пройти медицинский осмотр в течение одного дня;<br>
            • <strong>Легальность</strong> – в соответствии с Федеральным законом №99 профилактические медицинские
            осмотры могут
            проводиться только по адресу, указанному в лицензии,
            т.е. по месту нахождения лечебного учреждения;<br>
            • <strong>Лояльная ценовая политика</strong> – мы являемся лидерами по соотношению цена – качество, и всегда
            готовы сделать
            максимально выгодное индивидуальное
            предложение;<br>
            • <strong>Транспортная доступность</strong> – мы находимся в центре Москвы в шаговой доступности от метро
            Смоленская.</p>
        <!--        <div class="divider"></div>-->
        <!--        <div class="table-state" :class="{'open': showTable === 3}" @click="selectTable(3)">-->
        <!--            <h3>ПОРЯДОК ПРОВЕДЕНИЯ ПРЕДВАРИТЕЛЬНЫХ ОСМОТРОВ</h3>-->
        <!--            <div class="plus" v-if="showTable !== 3">-->
        <!--                <img class="plus"-->
        <!--                     src="../../assets/images/accordion_plus.png"-->
        <!--                     alt="">-->
        <!--            </div>-->
        <!--            <div class="minus" v-if="showTable === 3">-->
        <!--                <img src="../../assets/images/accordion_minus.png" alt="">-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <transition name="fade">-->
        <!--            <div v-if="showTable === 3">-->
        <!--                <p>1. Предварительные осмотры проводятся при поступлении на работу на основании направления на-->
        <!--                    медицинский-->
        <!--                    осмотр, выданного лицу, поступающему на работу, работодателем.-->
        <!--                    В Направлении указываются вредные производственные факторы, а также вид работы.<br>-->
        <!--                    2. Для прохождения предварительного осмотра лицо, поступающее на работу, представляет в медицинскую-->
        <!--                    организацию следующие документы: направление; паспорт; паспорт здоровья работника (при наличии);-->
        <!--                    решение-->
        <!--                    врачебной комиссии, проводившей обязательное психиатрическое освидетельствование (в случаях,-->
        <!--                    предусмотренных законодательством Российской Федерации).<br>-->
        <!--                    3. На лицо, проходящее предварительный осмотр, в медицинской организации оформляются:-->
        <!--                    <br>• медицинская карта амбулаторного больного, в которой отражаются заключения врачей-специалистов,-->
        <!--                    результаты лабораторных и инструментальных исследований, заключение по результатам предварительного-->
        <!--                    или-->
        <!--                    периодического медицинского осмотра. Медицинская карта хранится в медицинской организации;-->
        <!--                    <br>• паспорт здоровья работника — в случае если он ранее не оформлялся, в котором указывается-->
        <!--                    наименование-->
        <!--                    вредного производственного фактора; заключения врачей-специалистов, принимавших участие в проведении-->
        <!--                    предварительного или периодического медицинского осмотра работника, результаты лабораторных и-->
        <!--                    инструментальных исследований, заключение по результатам предварительного или периодического-->
        <!--                    медицинского осмотра.-->
        <!--                    В момент прохождения работником предварительного медицинского осмотра паспорт здоровья находится в-->
        <!--                    медицинской организации. По окончании осмотра паспорт здоровья выдается работнику на руки.<br>-->
        <!--                    4. Предварительный осмотр является завершенным в случае осмотра лица, поступающего на работу, всеми-->
        <!--                    врачами-специалистами, а также выполнения полного объема лабораторных и функциональных исследований,-->
        <!--                    предусмотренных Перечнем вредных и (или) опасных производственных факторов (приложение N 1, Приказ-->
        <!--                    29н)-->
        <!--                    и (или) Перечнем работ (приложение N 2, Приказ 29н).<br>-->
        <!--                    5. По окончании прохождения лицом, поступающим на работу, предварительного осмотра медицинской-->
        <!--                    организацией оформляется заключение, в котором указывается результат медицинского осмотра-->
        <!--                    (медицинские-->
        <!--                    противопоказания выявлены, не выявлены).</p>-->
        <!--            </div>-->
        <!--        </transition>-->
        <!--        <div class="divider"></div>-->
        <!--        <div class="table-state" :class="{'open': showTable === 4}" @click="selectTable(4)">-->
        <!--            <h3>ПОРЯДОК ПРОВЕДЕНИЯ ПЕРИОДИЧЕСКИХ ОСМОТРОВ</h3>-->
        <!--            <div class="plus" v-if="showTable !== 4">-->
        <!--                <img class="plus"-->
        <!--                     src="../../assets/images/accordion_plus.png"-->
        <!--                     alt="">-->
        <!--            </div>-->
        <!--            <div class="minus" v-if="showTable === 4">-->
        <!--                <img src="../../assets/images/accordion_minus.png" alt="">-->
        <!--            </div>-->
        <!--        </div>-->
        <!--        <transition name="fade">-->
        <!--            <div v-if="showTable === 4">-->
        <!--                <p>1. Периодические осмотры проводятся на основании поименных списков сотрудников с указанием вредных-->
        <!--                    производственных факторов.-->
        <!--                    Частота проведения периодических осмотров определяется типами вредных производственных факторов,-->
        <!--                    воздействующих на работника. Работники в возрасте до 21 года проходят периодические осмотры-->
        <!--                    ежегодно.-->
        <!--                    Внеочередные медицинские осмотры проводятся на основании медицинских рекомендаций, указанных в-->
        <!--                    заключительном акте.<br>-->
        <!--                    2. На основании списков медицинская организация составляет календарный план проведения-->
        <!--                    периодического-->
        <!--                    осмотра и формирует маршрут пациента с указанием специалистов и обследований.<br>-->
        <!--                    3. Периодический осмотр является завершенным в случае осмотра работника всеми врачами-специалистами,-->
        <!--                    а-->
        <!--                    также выполнения полного объема лабораторных и функциональных исследований, предусмотренных в-->
        <!--                    Перечне-->
        <!--                    факторов или Перечне работ.<br>-->
        <!--                    На основании результатов периодического осмотра в установленном порядке определяется принадлежность-->
        <!--                    работника к одной из диспансерных групп, с последующим оформлением в медицинской карте и паспорте-->
        <!--                    здоровья рекомендаций по профилактике заболеваний, в том числе профессиональных заболеваний, а при-->
        <!--                    наличии медицинских показаний — по дальнейшему наблюдению, лечению и реабилитации.<br>-->
        <!--                    4. По итогам проведения осмотров медицинская организация не позднее чем через 30 дней после-->
        <!--                    завершения-->
        <!--                    периодического медицинского осмотра обобщает результаты проведенных периодических осмотров-->
        <!--                    работников и-->
        <!--                    составляет заключительный акт в 4-х экземплярах . Этот документ потребуется работодателю при-->
        <!--                    проверках-->
        <!--                    Роспотребнадзора.</p>-->
        <!--            </div>-->
        <!--        </transition>-->
        <div class="divider"></div>
        <p style="text-align: center"><strong>Данные о прохождении медицинских осмотров подлежат внесению в личные
            медицинские книжки.</strong></p>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 1}" @click="selectTable(1)">
            <h3>Прейскурант на предварительный осмотр</h3>
            <div class="plus" v-if="showTable !== 1">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 1">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <prices-table v-if="showTable === 1" @sort="sortData" @pageChanged="currentPage" @scrollTop="scroll"
                          ref="scrollTo"
                          :data="priceAndServices"></prices-table>
        </transition>
        <div class="divider"></div>
        <div class="table-state" :class="{'open': showTable === 2}" @click="selectTable(2)">
            <h3>Прейскурант на периодический осмотр</h3>
            <div class="plus" v-if="showTable !== 2">
                <img class="plus"
                     src="../../assets/images/accordion_plus.png"
                     alt="">
            </div>
            <div class="minus" v-if="showTable === 2">
                <img src="../../assets/images/accordion_minus.png" alt="">
            </div>
        </div>
        <transition name="fade">
            <prices-table v-if="showTable === 2" @sort="sortData" @pageChanged="currentPage" @scrollTop="scroll"
                          ref="scrollTo"
                          :data="priceAndServices"></prices-table>
        </transition>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import ServiceAndPricesMixin from "@/mixins/ServiceAndPricesMixin";
import pricesTable from "@/components/pricesTable";
import StaticPageContactForm from "@/components/StaticPageContactForm";

export default {
    name: "examinations",
    mixins: [ServiceAndPricesMixin],
    components: {
        ContentHeader,
        pricesTable,
        StaticPageContactForm
    },
    data() {
        return {
            showTable: false
        }
    },
    methods: {
        selectTable(id) {
            this.showTable = this.showTable === id ? null : id
            const query = {...this.$route.query}
            query.type = id
            this.$router.replace({query})
                .catch(() => {
                })
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

.width-100 {
    width: 100%;
    display: flex;
    align-items: center;
}

.width-100 > span {
    height: 1px;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 auto;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    min-width: 10%;
}

.width-100 > span > span {
    border-color: #ebebeb;
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
}

h4 {
    font-weight: normal;
    color: #000;
    padding: 0 10px;
    background-color: #f5f5f5;
    width: fit-content;
    margin: auto;
}

.table-state {
    color: #666;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    position: sticky;

    &.open {
        padding: 10px 12px;
        background: #006688;
        color: white;
        margin-bottom: 20px;
    }

    h3 {
        font-size: 18px;
        font-weight: normal;
    }

    h3:hover {
        color: #3156A3;
    }

    &.open h3:hover {
        color: white;
    }

    @media screen and (max-width: 510px) {
        font-size: 11px;
    }
    @media screen and (max-width: 768px) {
        top: 0;
    }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity .4s, max-height .6s;
    max-height: 1000px;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
    max-height: 0;
}

</style>
